module.exports = __webpack_public_path__ + "static/img/img1.51364f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img1.png
// module id = M3eK
// module chunks = 21